import { Loader2 } from 'lucide-react';

import { TaskCategory } from '../types';
import { TaskPeriod } from '../index';

import { TaskCard } from './TaskCard';

import { useNewYearTasks } from '@/hooks/useNewYearCampaign';

interface TaskListProps {
  period: TaskPeriod;
  category: TaskCategory | null;
}

export function TaskList({ period, category }: TaskListProps) {
  const { data, isLoading, error } = useNewYearTasks(period, category || undefined);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 animate-spin text-cyan-400" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-red-400">Failed to load tasks</p>
        <p className="text-gray-500 text-sm mt-2">Please try again later</p>
      </div>
    );
  }

  const tasks = data?.tasks || [];

  if (tasks.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">No tasks available</p>
        <p className="text-gray-500 text-sm mt-2">
          {period === 'daily' && 'Check back tomorrow for new daily tasks!'}
          {period === 'weekly' && 'New weekly tasks will be available next week.'}
          {period === 'campaign' && 'Complete other tasks to unlock campaign challenges.'}
        </p>
      </div>
    );
  }

  // Sort tasks: incomplete first, then by sort order
  const sortedTasks = [...tasks].sort((a, b) => {
    if (a.isCompleted !== b.isCompleted) {
      return a.isCompleted ? 1 : -1;
    }
    return 0;
  });

  return (
    <div className="space-y-3">
      {sortedTasks.map((task) => (
        <TaskCard key={task.id} task={task} />
      ))}
    </div>
  );
}
